import React, { useState } from 'react';
import { MapPin, ShoppingBag, Search, Gift, HelpCircle, User as UserIcon } from 'lucide-react';
import EditProfileModal from '../../components/EditProfileModal';
import { useAuth } from '../../context/AuthContext';
import VideoLoader from "../../components/VideoLoader";
import { useNavigate } from 'react-router-dom';
import LeftArrow from '../../assests/left-arrow.svg';
import Copy_icon from '../../assests/copy.svg';
import ErrorHandlerPage from '../../components/ErrorHandlerPage';
export default function AccountPage() {
  const [showEditModal, setShowEditModal] = useState(false);
  const [fatalError, setFatalError] = useState<string | null>(null);
  const { user } = useAuth();
    const navigate = useNavigate();
  
    // const [displayUser, setDisplayUser] = useState(user);


  if (!user) {
    navigate('/');
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50 m-0" style={{ backgroundColor: 'var(--bw-bg)' }}>
        <VideoLoader size="medium" />
      </div>
    );
  }

  if (fatalError) {
    return (
      <ErrorHandlerPage
        title="Unable to Update Profile"
        description={fatalError}
        retryLabel="Back to Profile"
        onRetry={() => setFatalError(null)}
      />
    );
  }


  return (
    <div className="min-h-screen bg-white">
  

      {/* Hero Section with User Info */}
      
        <div className="bg-white px-4 sm:px-6 py-4 ">
   <div className="max-w-4xl mx-auto px-2 sm:px-4">
          <div className="flex items-center gap-3 sm:gap-4 h-[40px]">
            <button
              className="rounded-full flex items-center justify-center w-[35px] h-[35px] flex-shrink-0 border border-black/20 bg-white"
              onClick={() => navigate(-1)}
            >
              <img src={LeftArrow} alt="Back" className="w-4 h-4 dm-icon-invert" />
            </button>

            <h2 className="text-[18px] sm:text-[20px] font-bold m-0 leading-none text-black">
              Account Information
            </h2>
          </div>
        </div>
          </div>
             <div className=" text-white p-4 sm:p-6 ">

         

      {/* User Details Section */}
              <div className="max-w-4xl mx-auto  p-2 sm:p-4 pt-1 pb-20">
                
                <div className="w-full bg-white py-3 px-3 sm:px-4 border-[1px] border-black/20 rounded-2xl overflow-hidden">
                <div className="flex justify-center items-center gap-3 sm:gap-4 flex-row border-b border-black/20 py-3">
                  <div className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] flex-shrink-0 rounded-full flex items-center justify-center text-2xl sm:text-3xl font-bold select-none" style={{ backgroundColor: 'var(--bw-black)', color: 'var(--bw-white)' }}>
                    {(user?.name || 'U').charAt(0).toUpperCase()}
                  </div>
                   <div className='w-full flex flex-col  px-[12px] sm:px-[15px] py-[12px] sm:py-[20px]  transition  last:border-b-0 min-w-0'>
                      <p className="text-[17px] sm:text-[19px] text-black font-medium mb-0">Name</p>
                      <p className="text-gray-600 text-[14px] sm:text-[15px] mb-0 truncate">{user.name}</p>
                    </div>
                    <div className='cursor-pointer flex-shrink-0 w-[24px] h-[24px] sm:w-auto sm:h-auto'  onClick={() => setShowEditModal(true)}>
                      <img src={Copy_icon} alt="User Avatar" className="w-full h-full rounded-full object-cover dm-icon-invert" />
                    </div>
                    </div>
                  <div className="flex justify-center items-center gap-3 sm:gap-4 flex-row border-b border-black/20 py-3">
                  <div className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] px-[12px] sm:px-[15px] py-[12px] sm:py-[20px]  flex-shrink-0  rounded-full  items-center justify-center text-white text-2xl font-bold">
                  
              <div className={` p-2 bg-transparent  w-[40px] h-[40px] sm:w-[45px] sm:h-[45px] flex-shrink-0  border-[1px] border-black/20 rounded-full flex items-center justify-center`}>

                      <svg xmlns="http://www.w3.org/2000/svg" 
                       className="w-full h-full rounded-full object-cover text-black"
                        viewBox="0 0 640 640">
                       <path d="M224.2 89C216.3 70.1 195.7 60.1 176.1 65.4L170.6 66.9C106 84.5 50.8 147.1 66.9 223.3C104 398.3 241.7 536 416.7 573.1C493 589.3 555.5 534 573.1 469.4L574.6 463.9C580 444.2 569.9 423.6 551.1 415.8L453.8 375.3C437.3 368.4 418.2 373.2 406.8 387.1L368.2 434.3C297.9 399.4 241.3 341 208.8 269.3L253 233.3C266.9 222 271.6 202.9 264.8 186.3L224.2 89z"
                        fill="currentColor"/> 
                      </svg>
                      </div> 
                      </div>
                    <div className=" w-full flex flex-col px-[12px] sm:px-[15px] py-[12px] sm:py-[20px] transition last:border-b-0 min-w-0">
                      <p className="text-[17px] sm:text-xl font-medium text-black mb-0">Phone number</p>
                      <p className="text-gray-600 text-[14px] sm:text-[15px] mb-0 ">{user.phonenumber}</p>
                    </div>
                    </div>
                    <div className="flex justify-center items-center gap-3 sm:gap-4 flex-row py-3">
                  <div className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] px-[12px] sm:px-[15px] py-[12px] sm:py-[20px]  flex-shrink-0  rounded-full  items-center justify-center text-white text-2xl font-bold">
               
              <div className={` p-2 bg-transparent  w-[40px] h-[40px] sm:w-[45px] sm:h-[45px] flex-shrink-0  border-[1px] border-black/20 rounded-full flex items-center justify-center`}>

                      <svg xmlns="http://www.w3.org/2000/svg" className="text-black" viewBox="0 0 640 640">
                        <path
                          d="M64 416L64 192C64 139 107 96 160 96L480 96C533 96 576 139 576 192L576 416C576 469 533 512 480 512L360 512C354.8 512 349.8 513.7 345.6 516.8L230.4 603.2C226.2 606.3 221.2 608 216 608C202.7 608 192 597.3 192 584L192 512L160 512C107 512 64 469 64 416z"
                          fill="currentColor"
                        />
                      </svg>
                      </div>
                  
                      </div>
                    <div className=" w-full flex flex-col px-[12px] sm:px-[15px] py-[12px] sm:py-[20px] transition last:border-b-0 min-w-0">
                      <p className="text-[17px] sm:text-xl font-medium text-black mb-0">Email</p>
                      <p className="text-gray-600 text-[14px] sm:text-[15px] mb-0">{user.email}</p>
                    </div>  
                 
                    </div>
                  
                </div>
              </div>
              </div>

                <EditProfileModal 
                  isOpen={showEditModal}
                  onClose={() => setShowEditModal(false)}
                  onFatalError={(message) => {
                    setShowEditModal(false);
                    setFatalError(message);
                  }}
                  user={{
                    name: user.name,
                    email: user.email,
                    phone: user.phonenumber,
                    id: user.id
                  }}

                />
      
    </div>
  );
}
